/* RMS ZEITMEISTER — video bolumu davranislari
   (24 Agustos 2026 · 25 Agustos 2026'da video duzeltmeleri eklendi · 9 Eylul 2026 iOS jestleri)

   1) MOTTO ANIMASYONU
      Marka mottosunun animasyonunu sayfa yuklendiginde degil, video bolumu
      EKRANA GIRDIGINDE baslatir. Uc bolum: hakkimizda (video_LEGz3W),
      urun sayfasi (video_mqKEcr), ana sayfa (video_zij4wi). Bolum id'si temaya
      gore degistigi icin SONEK eslesmesi kullaniliyor.
      Yedek davranis: JS calismazsa animasyon CSS'teki haliyle sayfa yuklenirken
      baslar — motto yine gorunur, sadece zamanlamasi ideal olmaz.

   2) OTOMATIK OYNATMA ENGELLENIRSE DOKUNARAK BASLATMA
      OLCULEN SORUN: Focal'in `native-video` bileseni, `autoplay` niteligi varsa
      kapak katmanini DOM'dan SILMIYOR ve elemana tiklama dinleyicisi de
      BAGLAMIYOR (kaynakta: `this.autoPlay ? this.play() : this.addEventListener("click", ...)`).
      Kapak katmani (`.video-wrapper__poster`) videonun tamamini ortuyor —
      `elementFromPoint` videonun ortasinda `<video>` degil bu div'i donduruyordu.
      Sonuc: tarayici otomatik oynatmayi engellerse (pil tasarrufu, veri tasarrufu,
      tarayici ayari) kullanici videoyu HICBIR SEKILDE baslatamiyordu — siyah kutu.
      Burada elemana kendi tiklama dinleyicimizi baglıyoruz; kapagin dokunmayi
      yutmasi da rms-mobile.css 13. bolumde `pointer-events:none` ile kaldirildi.

   3) EKRANA GIRMEDEN VIDEO INDIRILMESIN
      `native-video` yapicisinda dogrudan `play()` cagiriyor; yani video sayfa
      acilir acilmaz, daha ekranda degilken inmeye basliyor. Ana sayfada ve urun
      sayfasinda video KATLAMANIN ALTINDA. Ekran disindaysa duraklatiyor,
      bolum gorunur olunca oynatiyoruz. Mobil veri ve LCP icin onemli.

   4) OYNAT DUGMESI ASLA GOSTERILMEZ — ILK DOKUNUSTA SESSIZCE BASLATILIR
      ⛔ KURAL (Yigit, 25 Agustos 2026): "ben zaten hiç oynatma düğmesinin
      çıkmasını istemiyorum, asla ama asla o çıkmasın, siteyi ziyaret edene
      gözükmesin." Bu yuzden kendi oynat dugmemiz YOK; daha once yazilan
      `rms-video--blocked` sinifi ve CSS'teki daire/ucgen KALDIRILDI.
      BU BOLUME BIR DAHA OYNAT DUGMESI EKLEME.

      Bunun yerine: tarayici otomatik oynatmayi reddederse (pil tasarrufu, veri
      tasarrufu, tarayici ayari) videoyu kullanicinin SAYFADAKI ILK HAREKETINDE
      baslatiyoruz — dokunma, tiklama, kaydirma ya da tus. Sessiz video icin bu
      hareket gecerli bir kullanici jesti sayilir ve `play()` kabul edilir.
      Kullanici bir dugme gormez, bir sey yaptigini fark etmez; video baslar.
      Dinleyiciler `{once:true}` ve basarida hepsi sokuluyor.

      9 EYLUL 2026 — iOS PIL TASARRUFU MODU (Yigit'in ekran goruntusu: sari pil,
      siyah kutu, ortada buyuk oynat simgesi). Iki olcum:
      (a) iOS Safari kullanici jesti olarak `touchstart`/`scroll`u SAYMAZ;
          `touchend`, `pointerup`, `click`, `keydown` sayar. Listeye `touchend`
          ve `pointerup` eklendi — ilk dokunusun BITISINDE video basliyor.
      (b) Ortadaki simge Safari'nin kendi `::-webkit-media-controls-start-playback-button`
          katmani; sections/video.liquid icindeki <style> ile gizlendi.
      (c) Kapak karesi: videonun Shopify onizleme karesi SIYAHTI (olculdu, tek renk).
          Files'ta videonun onizlemesi 3,5. saniyedeki atolye karesiyle degistirildi
          (fileUpdate previewImageSource); video.liquid `preview_image`i kullandigi
          icin artik siyah kutu yerine gercek kare gorunuyor.

      NOT: bazi mobil tarayicilar (Mi Browser, Samsung Internet) DURAKLAMIS bir
      videonun uzerine KENDI oynat simgesini cizer; o tarayicinin arayuzudur,
      CSS ile kaldirilamaz. Tek caresi videoyu gercekten oynatmaktir — yukaridaki
      jest yakalama tam olarak bunun icin var. Video oynamaya basladigi anda o
      simge de kaybolur. */
(function () {
  var SECTIONS = ['__video_LEGz3W', '__video_mqKEcr', '__video_zij4wi'];

  /* ---------- 1) MOTTO ---------- */
  function armMotto(section) {
    var content = section.querySelector('.video-wrapper__poster-content');
    if (!content) return;

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          content.style.animation = 'none';
          void content.offsetWidth; /* reflow — animasyonu bastan baslatir */
          content.style.animation = '';
          io.disconnect();
          return;
        }
      }
    }, { threshold: 0.35 });

    io.observe(section);
  }

  /* ---------- 2-3-4) VIDEO ---------- */
  function armVideo(host) {
    function el() { return host.querySelector('video'); }

    /* touchend + pointerup: iOS Safari'nin kullanici jesti saydigi olaylar (9 Eylul 2026) */
    var GESTURES = ['touchstart', 'touchend', 'pointerdown', 'pointerup', 'click', 'keydown', 'scroll'];
    var gestureArmed = false;

    function dropGestures() {
      if (!gestureArmed) return;
      gestureArmed = false;
      for (var g = 0; g < GESTURES.length; g++) {
        document.removeEventListener(GESTURES[g], onGesture, true);
      }
    }

    function onGesture() {
      var v = el();
      if (!v) return;
      if (!v.paused) { dropGestures(); return; }
      var p = v.play();
      if (p && typeof p.then === 'function') {
        p.then(dropGestures, function () { /* hala engelli — dinlemeye devam */ });
      } else {
        dropGestures();
      }
    }

    /* Otomatik oynatma reddedilirse kullanicinin ILK hareketini bekle ve
       sessizce baslat. Hicbir dugme gosterilmez (bkz. dosya basi, 4. madde). */
    function armGestures() {
      if (gestureArmed) return;
      gestureArmed = true;
      for (var g = 0; g < GESTURES.length; g++) {
        document.addEventListener(GESTURES[g], onGesture, true);
      }
    }

    function tryPlay() {
      var v = el();
      if (!v) return;
      var p = v.play();
      if (p && typeof p.then === 'function') {
        p.then(dropGestures, armGestures);
      }
    }

    /* Video oynamaya baslarsa jest dinleyicilerine gerek kalmaz */
    host.addEventListener('play', dropGestures, true);

    /* Elemana dokunmak da baslatsin — Focal autoplay modunda bunu baglamiyor */
    host.addEventListener('click', function () {
      var v = el();
      if (v && v.paused) tryPlay();
    });

    if (!('IntersectionObserver' in window)) { tryPlay(); return; }

    /* DIKKAT: burada `getBoundingClientRect` ile "ekranda mi" diye BAKILMAZ.
       Denendi ve YANLIS sonuc verdi: DOMContentLoaded aninda ustteki gorseller
       daha boyutlanmadigi icin sayfa kisa oluyor ve katlamanin cok altindaki
       video bolumu bile "ekranda" gorunuyordu (olculdu: bolumun gercek konumu
       3543px, o anda ise ekran icinde sanildi) — video hic duraklamadi.
       IntersectionObserver'in ILK geri cagrisi yerlesim tamamlandiktan sonra
       gelir; dogru olcum odur. */
    var pausedOnce = false;
    var visible = false;

    /* Ekran disindaysa indirmeyi durdur.
       BAYRAK ANCAK GERCEKTEN DURAKLATTIGIMIZDA set edilir ve video ortaya
       cikana kadar kisa arayla YENIDEN DENENIR. Kurul denetiminde olculdu:
       ILK IntersectionObserver geri cagrisi, `theme.js` daha calismadigi icin
       `<video>` henuz `<template>` icindeyken geliyor — `el()` null donuyor.
       IntersectionObserver ise durum degismedikce bir daha cagrilmiyor, yani
       tek denemeyle yetinilirse video hic duraklatilmiyor ve 40 MB'lik dosya
       katlamanin 3543 px altindayken iniyordu.
       YALNIZCA BIR KEZ duraklatiriz — kullanici sonradan elle baslatip asagi
       kaydirirsa onun kararini bozmayalim. */
    function pauseIfHidden() {
      if (visible || pausedOnce) return;
      var v = el();
      if (!v) return;
      pausedOnce = true;
      try { v.pause(); } catch (err) {}
    }

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      pauseIfHidden();
      if (pausedOnce || visible || tries > 30) clearInterval(timer);
    }, 100);

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          visible = true;
          clearInterval(timer);
          io.disconnect();
          tryPlay();
          /* Emniyet agi: `play()` bir soz dondurmeyen eski tarayicilarda ya da
             sozun sessizce beklemede kaldigi durumlarda, 2,5 sn sonra video hala
             hic baslamamissa jest yakalamayi yine de kur. Hicbir dugme
             gosterilmez. */
          setTimeout(function () {
            var v = el();
            if (v && v.paused && v.currentTime === 0) armGestures();
          }, 2500);
          return;
        }

        visible = false;
        pauseIfHidden();
      }
    }, { threshold: 0.15 });

    io.observe(host);
  }

  function init() {
    if (!('IntersectionObserver' in window)) return;

    for (var i = 0; i < SECTIONS.length; i++) {
      var s = document.querySelector('[id$="' + SECTIONS[i] + '"]');
      if (s) armMotto(s);
    }

    var hosts = document.querySelectorAll('native-video[autoplay]');
    for (var j = 0; j < hosts.length; j++) armVideo(hosts[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
